<div class="card border-0 rounded-3 shadow">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">

            <div *ngIf="isPagination == true">
                <app-paginator [totalCount]="totalCount" [page]="page" (nextPage)="pageEvent($event)"></app-paginator>
            </div>

            <button *ngIf="isDownloadButtonShow" (click)="downloadCsvButton()"
                class="btn text-uppercase text-white download_btn me-3"><span><img
                        src="https://www.svgrepo.com/show/138917/download.svg" class="img-fluid" alt="" style="height: 20px; width: 20px; color: white; fill: white;"></span>
            </button>

            <div *ngIf="publishButton">
                <button class="btn btn-sm reject_btn me-3" (click)="approveReject(0)">
                    <span><img src="/assets/images/rejectIcon-shg.svg" alt=""></span>
                    Unpublish
                </button>
                <button class="btn aprove_btn btn-sm" (click)="approveReject(1)">
                    <span><img src="/assets/images/approveIcon-shg.svg" alt=""></span>
                    Publish
                </button>
            </div>

        </div>
        <div class="table-responsive">
            <table class="table table-borderless">
                <thead class="bg-blue">
                    <!-- <tr> -->
                    <!-- <th class="text-white border-0"><span class="">S.No.</span></th> -->

                    <th class="border-0 fs-14" *ngFor="let heading of tableHeader">
                        {{ heading?.label }}
                    </th>
                    <!-- </tr> -->
                </thead>
                <tbody>
                    <tr class="border-bottom fs-10" *ngFor="let record of masterData; let sno = index;">

                        <td class="" width="10">{{ sno + 1 }}</td>

                        <!-- <td>{{  record | json}}</td> -->
                        <td>{{ record.SHG_Name }}</td>
                        <td>{{ record.accountNo }}</td>
                        <td>{{ record.proposedAmount }}</td>
                        <td>{{ record.submittedOn }}</td>
                        <td>{{ record.applicationType }}</td>
                        <td class="app-no">{{ record.applicationNo }}</td>

                        <td [ngClass]="{
                'statusApproved': record?.status == 'Sanctioned',
                'statusRejected': record?.status == 'Draft',
                'statusPending':  record?.status == 'Under Review'
              }">
                            <ng-container>{{record?.status}}</ng-container>
                        </td>

                        <!-- <td class="text-nowrap" width="90" style="cursor: pointer">
                            <img src="..//assets/icons/visibility_black_24dp.svg" alt="view icon"
                                (click)="editData(record, false)" *ngIf="checkAvailablitiy('Edit')" />
                            <img src="..//assets/icons/edit_black_24dp.svg" alt="edit icon" (click)="editData(record)"
                                *ngIf="checkAvailablitiy('Update')" />
                            <img src="..//assets/icons/delete_black_24dp.svg" (click)="openDeleteDialog(record)"
                                alt="delete icon" *ngIf="checkAvailablitiy('Delete')" />
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="withdraw-dialogue">

</div>